import { takeLatest, fork, call, put, select } from 'redux-saga/effects'
import { showSpinner, hideSpinner } from '../../modules/global/actions'

import { fetchBillingPeriods } from '../../modules/billing/sagas'
import { makeSelectBillingPeriods } from '../../modules/billing/selectors';
import * as usageActions from './actions'
import { sortBillingPeriodsByLatest } from '../../utils/helpers';
import { ApiRequest } from '../../utils/api';
import { doCallApi } from '../global/sagas'
import { SUBSCRIPTION_USAGE_FETCH, INITIALIZE_SUBSCRIPTION_USAGE, INITIALIZE_ALL_USAGES, ALL_USAGES_FETCH } from './constants'

function* doInitializeSubscriptionUsage(action) {
  const { id } = action.payload;

  yield fetchBillingPeriods(id);
  const billingPeriods = yield select(makeSelectBillingPeriods());
  yield put(showSpinner());
  if (billingPeriods !== null) {
    const sortedPeriods = sortBillingPeriodsByLatest(billingPeriods);
    yield fetchSubscriptionUsage(id, sortedPeriods[0].startDate, sortedPeriods[0].endDate);
  }
  yield put(hideSpinner())
}


function* doInitializeAllUsages(action) {
  const { id } = action.payload;
  yield fetchBillingPeriods(id);
  const billingPeriods = yield select(makeSelectBillingPeriods());
  if (billingPeriods !== null) {
    const sortedPeriods = sortBillingPeriodsByLatest(billingPeriods);
    yield fetchAllUsages(id, sortedPeriods[0].startDate, sortedPeriods[0].endDate)
  }
}

export function* fetchAllUsages(accountId, startDate, endDate) {
  const { response, error } = yield call(doCallApi, true, ApiRequest.getAllUsages, accountId, startDate, endDate);
  if (error) {
    yield put(usageActions.receiveUsagesError())
  }
  if (response) {
    yield put(usageActions.receiveAllUsages(response))
  }
}


export function* fetchSubscriptionUsage(subscriptionId, startDate, endDate) {
  const { response, error } = yield call(doCallApi, true, ApiRequest.getSubscriptionUsage, subscriptionId, startDate, endDate);
  if (error) {
    yield put(usageActions.receiveUsagesError())
  }
  if (response) {
    yield put(usageActions.receiveSubUsage(response))
  }
}

// helper function to fetch all usages
function* doFetchAllUsages(action) {
  const { id, startDate, endDate } = action.payload;
  yield fetchAllUsages(id, startDate, endDate);
}

// helper function to fetch usage for individual subscription
function* doFetchSubscriptionUsage(action) {
  yield put(showSpinner());
  const { id, startDate, endDate } = action.payload;
  yield fetchSubscriptionUsage(id, startDate, endDate);
  yield put(hideSpinner())
}


export function* root() {
  yield fork(takeLatest, SUBSCRIPTION_USAGE_FETCH, doFetchSubscriptionUsage);
  yield fork(takeLatest, INITIALIZE_SUBSCRIPTION_USAGE, doInitializeSubscriptionUsage);
  yield fork(takeLatest, INITIALIZE_ALL_USAGES, doInitializeAllUsages);
  yield fork(takeLatest, ALL_USAGES_FETCH, doFetchAllUsages)
}

export default [
  root,
];
